import { CustomTable } from "../../../../../../../../components";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { RefTable } from "../../../../../../../../components/table/types";
import { useContextState } from "../../../../../../../../hooks/theme";
import { FilterBody } from "../../../../../../../../hooks/filter/typing";
import { Box, Icon, List, ListItem, Tooltip, Typography } from "@mui/material";
import { icons } from "../../../../../../../../utils/icons";
import { useStyles } from "./styles";


export const InternalDetail = ({ row, isLoading, filterUserInternal, totalPages }: { totalPages: number; row: any, isLoading: boolean, filterUserInternal: FilterBody }) => {

    const { t } = useTranslation()
    const refTable = useRef<RefTable>(null)
    const { colors } = useContextState()
    const styles = useStyles()
    const { paginationModel, handlePagination } = filterUserInternal;

    const column = [
        {
            id: 'name',
            label: t('userGroup.columns.userName'),
            minWidth: 100,
        },
        {
            id: 'role',
            label: t('userGroup.columns.role'),
            minWidth: 100,
        },
        {
            id: 'userType',
            label: t('userGroup.columns.userType'),
            minWidth: 100,
        },
        {
            id: 'areaName',
            label: t('userGroup.columns.area'),
            sortable: true,
            renderCell: (params: any) => {
                const areaArray = params.current ? params.current.split(',').map((item: string) => item.trim()) : undefined;
                const firstTwoAreas = areaArray?.slice(0, 2);
                const remainingAreas = areaArray?.slice(2);
                return (
                    <Box>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoAreas?.join(', ')}
                            {remainingAreas?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingAreas.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!areaArray && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            id: 'departmentName',
            label: t('userGroup.columns.department'),
            sortable: true,
            renderCell: (params: any) => {
                const departmentArray = params.current ? params.current.split(',').map((item: string) => item.trim()) : undefined;
                const firstTwoDepartments = departmentArray?.slice(0, 2);
                const remainingDepartments = departmentArray?.slice(2);
                return (
                    <Box /* sx={styles.containerStatus} */>
                        <Typography sx={styles.areaTitle}>
                            {firstTwoDepartments?.join(', ')}
                            {remainingDepartments?.length > 0 && (
                                <Tooltip
                                    title={
                                        <List>
                                            {remainingDepartments.map((item: string, index: number) => (
                                                <ListItem key={index} style={{ padding: 0 }}>
                                                    {item}
                                                </ListItem>
                                            ))}
                                        </List>
                                    }
                                >
                                    <Icon sx={styles.viewMore}>{icons('add')}</Icon>
                                </Tooltip>
                            )}
                            {!departmentArray && 'N/A'}
                        </Typography>
                    </Box>
                )
            },
        },
    ]

    return (
        <CustomTable
            ref={refTable}
            loader={isLoading}
            dontRefresh
            column={column}
            row={row ?? []}
            color={colors}
            serverSidePagination={{ page: paginationModel.page + 1, size: paginationModel.pageSize, totalPages: totalPages }}
            handleChange={(page: number, pageSize: number) => {
                handlePagination({ page, pageSize })
            }}
        />
    )
}